import axios from 'axios';
import { from } from 'rxjs';

// Who signed a document through validate.ge (vsys docs/signings-runbook.md
// §2.b-2.f): the signed versions stored through it, not the file's
// signatures. Every call by the document's exposed id; refusals as
// problem+json, shown by the callers.
const quiet = { skipCustomErrorHandling: true };
const doc = (docId) => `${globalConfig.api_URL}api/v2/private/document/${docId}`;

class SigningService {
    // every signing the caller may see, newest first, in one answer ->
    // { docExposedId, signings: [{ processId, signedAt, signedBy {name, email},
    //   byCaller, shareId, throughLink, requiredSignatoryMet, verifiedSignatory }] }.
    // Only when the read's actionRights.signingList is true (never a public view).
    list = (docId) => from(axios.get(`${doc(docId)}/signings`, quiet));

    // the counts only (who signed is /signings) -> { docExposedId, signings,
    //   accounts, verifiedSignatories, requiredSignatories {total, signed},
    //   invitations {requested, signed, pending, closed} }; signed in only
    summary = (docId) => from(axios.get(`${doc(docId)}/signings/summary`, quiet));

    // the caller's view of the document's signings -> { docExposedId, scope:
    // ALL | SHARES | OWN, shareIds }; signed in only, never cached
    scope = (docId) => from(axios.get(`${doc(docId)}/signings/scope`, quiet));
}

export default new SigningService();
